import * as React from "react";
import { CalendarDays } from "lucide-react";
import { useDateFormatter } from "@/hooks/useDateFormatter";

interface Props {
  date: string;
}

export const EventDateAlert: React.FC<Props> = ({ date }) => {
  const { formatDate } = useDateFormatter();
  return (
    <div className="mt-3 flex items-center gap-1.5 text-xs text-muted-foreground">
      <CalendarDays className="h-3.5 w-3.5" />
      <span>Event Date: {formatDate(date)}</span>
    </div>
  );
};
